import React, { FC } from "react";
import styled, { css, themeGet } from "../../styles";
import { Tabs } from "react-tabs";

export const StyledAddTabContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const StyledAdCircuitContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
`;
